import{useDispatch}from'react-redux';export var useAppDispatch=function useAppDispatch(){return useDispatch();};